export function calculateBadgeTooltipPosition(
  badgeRect: DOMRect,
  tooltipSize: Pick<DOMRect, 'width' | 'height'>,
  viewportWidth: number,
  viewportHeight: number,
): { left: number; top: number; fitsRight: boolean } {
  const gap = 8;
  const fitsRight =
    badgeRect.right + gap + tooltipSize.width <= viewportWidth - gap;
  const left = fitsRight
    ? badgeRect.right + gap
    : Math.max(gap + tooltipSize.width, badgeRect.left - gap);
  const top = Math.min(
    Math.max(
      badgeRect.top + badgeRect.height / 2,
      gap + tooltipSize.height / 2,
    ),
    viewportHeight - gap - tooltipSize.height / 2,
  );

  return {
    left: Math.max(gap, Math.min(left, viewportWidth - gap)),
    top,
    fitsRight,
  };
}

export function showBadgeTooltip(
  badge: HTMLButtonElement,
  tooltip: HTMLSpanElement,
  view: Window | null,
): void {
  const tooltipElement = tooltip;
  tooltipElement.hidden = false;
  const badgeRect = badge.getBoundingClientRect();
  const bounds = tooltipElement.getBoundingClientRect();
  const width = bounds.width || tooltipElement.offsetWidth;
  const height = bounds.height || tooltipElement.offsetHeight;
  const gap = 8;
  const viewportWidth = view?.innerWidth ?? badgeRect.right + width + gap;
  const viewportHeight = view?.innerHeight ?? badgeRect.bottom + height + gap;
  const position = calculateBadgeTooltipPosition(
    badgeRect,
    { width, height },
    viewportWidth,
    viewportHeight,
  );

  tooltipElement.style.left = `${position.left}px`;
  tooltipElement.style.top = `${position.top}px`;
  tooltipElement.style.transform = position.fitsRight
    ? 'translateY(-50%)'
    : 'translate(-100%, -50%)';
}

export function hideBadgeTooltip(tooltip: HTMLSpanElement): void {
  const tooltipElement = tooltip;
  tooltipElement.hidden = true;
}
